import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setLoading,
  setCoupons,
  addCoupon,
  setEditingCouponId,
  updateCoupon,
  deleteCoupon,
  setError,
  setEditingCoupon,
} from "../../features/common/couponSlice";
import {
  addCoupons,
  couponUpdate,
  getCouponsById,
} from "../../services/userservice";
import * as moment from "moment";
import { useParams } from "react-router-dom";

const AddCoupons = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, editingCouponId } = useSelector(
    (state) => state.coupon
  );

  console.log("Loading state:", loading);
  console.log("Error state:", error);
  //const editingCouponId = useSelector((state) => state.coupon.edit_coupon_id);
  const editingCoupon = useSelector((state) => state.coupon.editingCoupon);

  const [validFrom, setValidFrom] = useState(null);
  const [validTo, setValidTo] = useState(null);

  const [formData, setFormData] = useState([
    {
      title: "",
      type: "",
      applicableTo: "",
      code: "",
      is_login: 0,
      targetAudience: "",
      discount: "",
      description: "",
      validFrom: null,
      validUntil: null,
      min_order_value:0,
      max_order_value:0
    },
  ]);


  useEffect(() => {
    if (id && id !== "add" && editingCouponId !== id) {
      dispatch(setEditingCouponId(id));
      dispatch(setEditingCoupon(id));
      fetchCouponData(id);
    }
  }, [id, editingCouponId, dispatch]);

  const fetchCouponData = async (id) => {
    try {
      dispatch(setLoading());
      const response = await getCouponsById(id);
      if (response) {
        // Update form data with fetched coupon data
        const responseData = response.data;
        setFormData({
          title: responseData.title,
          type: responseData.type,
          applicableTo: responseData.applicableTo,
          code: responseData.code,
          targetAudience: responseData.targetAudience,
          discountType: responseData.discountType,
          discount: responseData.discount,
          description: responseData.description,
          status: responseData.status,
          is_login: responseData.is_login,
          min_order_value: parseInt(responseData?.min_order_value),
          max_order_value:parseInt(responseData?.max_order_value),
          validFrom: moment(responseData.validFrom).format("MM/DD/YYYY"),
          validUntil: moment(responseData.validUntil).format("MM/DD/YYYY"),
        });
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false)); // Set loading to false after data is fetched or on error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(setLoading());
      const response =
        id && id !== "add"
          ? await couponUpdate(id, formData)
          : await addCoupons(formData);

      if (response) {
        dispatch(
          id && id !== "add" ? updateCoupon(formData) : addCoupon(formData)
        );
        navigate("/coupons");
      }
    } catch (error) {
      alert(error.message);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false)); // Set loading to false after form submission or on error
    }
  };

  const handleValidFromChange = (date) => {
    setValidFrom(date);
  };

  const handleValidToChange = (date) => {
    setValidTo(date);
  };

  const handleDateChange = (name, date) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: date,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "discountType") {
      setFormData({
          ...formData,
          [name]: value,
          value: "",
      });
  }else if (name === "min_order_value" || name === "max_order_value") {
      if (/^\d*\.?\d*$/.test(value)) {
          setFormData({
              ...formData,
              [name]: +value
          });
      }
  } else {
      let newValue = value;

      if (formData.discountType === "PERCENTAGE") {
          if (newValue > 100) {
              return;
          }
      } else if (formData.discount_type === "AMOUNT") {
          if (newValue > 1000) {
              return;
          }
      }
      setFormData({
          ...formData,
          [name]: newValue,
      });
  }
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   [name]: value,
    // }));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Add Coupons</h1>
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Coupons</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div classname="row">
            <div classname="col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Enter Title"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Select Coupons Type</label>
                          <select
                            className="form-control"
                            id="type"
                            name="type"
                            value={formData.type}
                            onChange={handleInputChange}
                          >
                          <option value="">Select  Type</option>
                            <option value="COUPON">COUPON</option>
                            <option value="OFFER">OFFER</option>
                            <option value="CASHBACK_OFFER">CASHBACK OFFER</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Select Applicable*</label>
                          <select
                            className="form-control"
                            id="applicableTo"
                            name="applicableTo"
                            value={formData.applicableTo}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Type</option>
                            <option value="FLIGHTS">FLIGHTS</option>
                            {/* <option value="OFFER">OFFER</option> */}
                            {/* <option value="CABS">CABS</option> */}
                            <option value="BUS">BUS</option>
                            {/* <option value="TRAINS">TRAINS</option> */}
                            <option value="HOTELS">HOTELS</option>
                            <option value="HOLIDAYS">HOLIDAYS</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Target User*</label>
                          <select
                            className="form-control"
                            id="targetAudience"
                            name="targetAudience"
                            value={formData.targetAudience}
                            onChange={handleInputChange}
                          >
                            <option value="ALL_USERS">ALL USERS</option>
                            <option value="NEW_USERS">NEW USERS</option>
                            <option value="RETURNING_USERS">
                              RETURNING USERS
                            </option>
                            <option value="PREMIUM_USERS">PREMIUM USERS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> Coupons Code</label>
                          <input
                            type="text"
                            className="form-control"
                            id="code"
                            name="code"
                            placeholder="Enter Coupons Code"
                            value={formData.code}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Discount Type</label>
                          <select
                            className="form-control"
                            id="discountType"
                            name="discountType"
                            value={formData.discountType}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Discount Type</option>
                            <option value="PERCENTAGE">Percenatge</option>
                            <option value="AMOUNT">Amount</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> Discount</label>
                          <input
                            type="text"
                            className="form-control"
                            id="discount"
                            name="discount"
                            placeholder="Enter Discounts Percentage"
                            value={formData.discount}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="min_order_value">Minimum Order Value</label>
                            <input
                                type="number"
                                className="form-control"
                                id="min_order_value"
                                placeholder="Minimum Order Value"
                                name="min_order_value"
                                value={formData.min_order_value}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="max_order_value">Maximum Order Value</label>
                            <input
                                type="number"
                                className="form-control"
                                id="max_order_value"
                                placeholder="Minimum Order Value"
                                name="max_order_value"
                                value={formData.max_order_value}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Valid From</label>
                          <DatePicker
                            selected={formData.validFrom}
                            onChange={(date) =>
                              handleDateChange("validFrom", date)
                            }
                            placeholderText="Select valid from date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Valid To</label>
                          <DatePicker
                            selected={formData.validUntil}
                            onChange={(date) =>
                              handleDateChange("validUntil", date)
                            }
                            placeholderText="Select valid to date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Status</label>
                          <select
                            className="form-control"
                            id="status"
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                          >
                            <option value="active">ACTIVE</option>
                            <option value="inactive">INACTIVE</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Is Login</label>
                          <select
                            className="form-control"
                            id="is_login"
                            name="is_login"
                            value={formData.is_login}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Login</option>
                            <option value="1">True</option>
                            <option value="0">False</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        rows="3"
                        placeholder="Enter descriptions..."
                        value={formData.description}
                        onChange={handleInputChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div></div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddCoupons;
